module.exports = __webpack_public_path__ + "static/media/methamphetamine.5e0a8f4f.svg";